// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"fec24819","466":"a0ce6d44","478":"8b91595d","559":"7156ccbb","682":"98e08963","685":"7374808b","702":"c32df7f2","726":"dd3de0f6","734":"d1ba6a44","750":"57834cd7","918":"aa8c753d","980":"09024ac0"}[chunkId] + ".chunk.js";
};